import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { LoggerService } from "@spartacus/core";
import { CartActions } from "@spartacus/cart/base/core";
import { concatMap, filter, map, take } from "rxjs";
import { ManageCartsActions } from "../actions";
import { SavedCartsService } from "../../services/saved-carts.service";
import { CustomSavedCartsData } from "../state/cart-details.state";

@Injectable()
export class SharedManageCartsEffects {

    protected logger = inject(LoggerService);

    constructor(
        public actions$: Actions,
        public savedCartsService: SavedCartsService,
    ) { }

    deleteCartSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CartActions.DELETE_CART_SUCCESS),
            concatMap((action: CartActions.DeleteCartSuccess) => this.savedCartsService.getCartFromDeleteCartIndex()
                .pipe(
                    filter((cartObj: CustomSavedCartsData) => action?.payload?.cartId === cartObj.code),
                    take(1)
                )
            ),
            map((data) => ManageCartsActions.setDeleteCartSuccess({ deleteCartStatus: true }))
        )
    );

    deleteCartFail$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CartActions.DELETE_CART_FAIL),
            concatMap((action: CartActions.DeleteCartFail) => this.savedCartsService.getCartFromDeleteCartIndex()
                .pipe(
                    filter((cartObj: CustomSavedCartsData) => action?.payload?.cartId === cartObj.code),
                    take(1)
                )
            ),
            map((data) => ManageCartsActions.setDeleteCartSuccess({ deleteCartStatus: false }))
        )
    );
}
